
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Punetomumbaiairportcab() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Airport Cab    ',
        heading: 'Deva Cabs: Pune to Mumbai Airport Cab',
        headingDescription: 'Deva Cabs provides fast, safe, and dependable cab services from Pune to Mumbai Airport, ideal for business trips, family travel, and urgent transfers. Covering the distance of approximately 150 km in 3 to 4 hours, our cabs ensure a smooth ride with professional drivers and well-maintained vehicles. Choose from a wide range including Sedan, SUV, or Innova Crysta, and enjoy door-to-door pickup, fixed pricing, and 24/7 availability. Trust Deva Cabs for stress-free airport transfers from Pune.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea and standing beside the Taj Mahal Palace Hotel, it is a popular starting point for ferry rides to Elephanta Caves and a must-visit historical attraction that symbolizes Mumbai’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6 km-long boulevard that curves along the coast from Nariman Point to Girgaon Chowpatty. Nicknamed the 'Queen’s Necklace' for its glittering lights at night, it's a favorite spot for peaceful walks, sunset views, and soaking in the coastal breeze with the city skyline as a backdrop."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, Elephanta Caves are a group of ancient rock-cut temples located on Elephanta Island. Accessible via ferry from the Gateway of India, the caves date back to the 5th–8th centuries and are famous for intricate carvings of Lord Shiva, especially the iconic Trimurti sculpture."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple is one of Mumbai’s most important spiritual centers. Known for its majestic architecture and the black stone idol with a trunk curving to the right, the temple attracts devotees from all walks of life, especially on Tuesdays when thousands come for darshan."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel that combines Victorian Gothic with traditional Indian design. Built in 1887, it remains a bustling transport hub and a monument that reflects Mumbai's colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a lively stretch of coastline known for its street food stalls, Bollywood celebrity homes, and sunset views. From children playing cricket to couples strolling by the waves, the beach buzzes with energy and offers a quintessential Mumbai experience with snacks like vada pav and bhel puri."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Situated on an islet off the coast of Worli, Haji Ali Dargah is a 15th-century Indo-Islamic shrine housing the tomb of Sufi saint Haji Ali Shah Bukhari. Accessible by a narrow causeway during low tide, the dargah offers spiritual tranquility along with breathtaking sea views."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "One of the world’s few national parks within city limits, Sanjay Gandhi National Park is a green haven offering nature trails, a toy train, boating, and wildlife like leopards and deer. The park is also home to the ancient Kanheri Caves, which showcase Buddhist rock-cut architecture dating back over 2,000 years."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, Mumbai, Maharashtra",
    "description": "One of India’s oldest flea markets, Chor Bazaar is a treasure trove of antiques, vintage Bollywood posters, rare coins, and quirky collectibles. Despite its name meaning 'Thieves’ Market', it’s a legal and lively destination for bargain hunters and curious tourists alike."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Located at the northern end of Marine Drive, Girgaon Chowpatty is a city beach known for its festive spirit, street food, and cultural gatherings. It becomes especially vibrant during Ganesh Chaturthi, when thousands gather for idol immersions in the Arabian Sea."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Deva Cabs offers reliable and comfortable cab services from Pune to Mumbai Airport, ensuring a stress-free transfer for all travelers. Whether you are heading to the domestic or international terminal, our experienced drivers guarantee timely pickups and smooth rides. Our fleet includes a wide range of vehicles with AC, spacious interiors, and ample luggage space to accommodate families, solo travelers, and business guests. We provide door-to-door service with real-time traffic monitoring to avoid delays and make your airport journey hassle-free."
  },
  {
    "name": "Cab from Pune to Mumbai T2",
    "description": "Book your cab from Pune to Mumbai Terminal 2 with Deva Cabs for a seamless airport transfer experience. Our dedicated drivers track your flight timings to ensure punctual drop-offs and provide courteous assistance throughout your trip. Choose from sedans, SUVs, and luxury cars equipped with air-conditioning and comfortable seating. Ideal for business travelers and families alike, our Pune to Mumbai T2 cab service offers transparent pricing and safe, reliable rides."
  },
  {
    "name": "Pune to Mumbai International Airport taxi",
    "description": "Travel in style and comfort with Deva Cabs’ taxi services from Pune to Mumbai International Airport. Our well-maintained vehicles feature modern amenities such as climate control, spacious seating, and ample storage for luggage. Our professional chauffeurs are experienced with the highway routes and ensure you reach the airport well ahead of your flight schedule. Whether it’s a business trip or vacation, we tailor our services to your needs with on-time pickups, clean cars, and flexible booking options."
  },
  {
    "name": "Affordable Pune to Airport cab",
    "description": "Looking for a budget-friendly cab from Pune to Mumbai Airport? Deva Cabs offers affordable rates without compromising on quality or comfort. Our economy cars provide efficient, reliable service for solo travelers and small groups, all with air-conditioning and safe driving practices. We pride ourselves on transparent pricing with no hidden charges, prompt pickups, and courteous drivers, making us a preferred choice for cost-conscious travelers."
  },
  {
    "name": "Pune to Mumbai Airport drop service",
    "description": "Ensure timely airport drop-offs with Deva Cabs’ Pune to Mumbai Airport drop service. Our drivers arrive punctually at your pickup location and handle your luggage with care, guaranteeing a hassle-free journey. Our vehicles are sanitized and maintained regularly to ensure safety and hygiene. Whether you are catching an early morning or late-night flight, we provide 24/7 availability, door-to-door convenience, and real-time updates to keep you informed throughout your trip."
  },
  {
    "name": "Luxury cab Pune to Mumbai Airport",
    "description": "Travel in luxury from Pune to Mumbai Airport with Deva Cabs’ premium cab services. Our fleet includes high-end sedans and SUVs from brands like Mercedes, BMW, and Audi, offering plush interiors, advanced climate control, and onboard entertainment options. Perfect for corporate travelers, VIP guests, and special occasions, our chauffeurs are trained to provide discreet, courteous service, ensuring you arrive at the airport relaxed and on time."
  },
  {
    "name": "One-way Pune Airport cab service",
    "description": "Deva Cabs provides efficient one-way cab services from Pune to Mumbai Airport for travelers who need straightforward, reliable transfers. Our fixed pricing policy ensures no surprises, and our professional drivers follow the best routes to avoid traffic delays. Choose from a variety of vehicle types based on your group size and budget, all equipped with air-conditioning and comfortable seating to guarantee a pleasant ride."
  },
  {
    "name": "Online Pune to Mumbai Airport cab booking",
    "description": "Booking your Pune to Mumbai Airport cab online is quick and convenient with Deva Cabs. Our website and app allow you to select your preferred vehicle, schedule your pickup time, and receive instant confirmation. We offer secure payment options and 24/7 customer support to assist with any booking changes or queries. Real-time tracking and driver details are shared in advance to ensure peace of mind for your airport transfer."
  },
  {
    "name": "Fast cab Pune to Mumbai Airport",
    "description": "Need a fast and reliable cab from Pune to Mumbai Airport? Deva Cabs offers quick dispatch and optimized route planning to ensure timely arrivals, even during peak traffic hours. Our drivers are well-trained to navigate efficiently and maintain safe speeds without compromising comfort. Perfect for last-minute trips or urgent flights, our fast cab service provides prompt pickups, real-time updates, and comfortable vehicles to help you catch your flight stress-free."
  },
  {
    "name": "SUV cab Pune to Mumbai Airport",
    "description": "Travel comfortably with family or a group in our spacious SUV cabs from Pune to Mumbai Airport. Deva Cabs’ SUVs like Toyota Innova, Mahindra XUV, and similar models offer ample legroom, reclining seats, and generous luggage capacity. Equipped with air-conditioning and modern amenities, these vehicles provide a smooth, relaxing ride suitable for long-distance travel. Our professional chauffeurs ensure safe driving and timely airport drop-offs."
  },
  {
    "name": "Pune to Mumbai Airport chauffeur service",
    "description": "Experience premium chauffeur-driven service from Pune to Mumbai Airport with Deva Cabs. Our trained drivers provide personalized, courteous assistance from pickup to drop-off, helping with luggage and ensuring a smooth journey. Our modern fleet is fully air-conditioned, clean, and equipped with all necessary comforts for a stress-free transfer. Ideal for corporate clients and travelers seeking luxury, our chauffeur service adds a professional touch to your airport commute."
  },
  {
    "name": "Pune to Mumbai domestic terminal cab",
    "description": "Deva Cabs provides specialized taxi services from Pune to Mumbai’s domestic terminal with prompt and reliable pickups. Our drivers are knowledgeable about the domestic terminal layout, ensuring seamless drop-offs close to your airline’s check-in counter. Vehicles are well-maintained and air-conditioned for comfort. Whether traveling solo or in groups, our Pune to Mumbai domestic terminal cabs offer flexible booking, transparent pricing, and courteous service."
  },
  {
    "name": "Family cab Pune to Airport Mumbai",
    "description": "Travel with your family comfortably and safely with Deva Cabs’ family cab services from Pune to Mumbai Airport. Our spacious vehicles offer ample seating and luggage space, child-friendly amenities, and smooth rides. Our drivers prioritize your family’s comfort and safety, assisting with luggage and ensuring timely arrivals. Suitable for small and large families, our family cab service makes your airport transfer convenient and enjoyable."
  },
  {
    "name": "Night cab Pune to Mumbai Airport",
    "description": "Deva Cabs provides reliable night cab services from Pune to Mumbai Airport for travelers with late-night or early-morning flights. Our drivers are experienced in night driving and committed to safety, ensuring a secure and comfortable journey. Vehicles are sanitized and equipped with bright interiors and proper lighting for your convenience. Available 24/7, our night cab service offers flexible booking and real-time tracking to suit your travel schedule."
  },
  {
    "name": "AC cab Pune to Mumbai T2",
    "description": "Stay cool and comfortable in our fully air-conditioned cab services from Pune to Mumbai Terminal 2. Deva Cabs offers modern vehicles with efficient cooling systems, ensuring a refreshing ride regardless of the season. Our professional drivers maintain cleanliness and hygiene standards, guaranteeing a pleasant journey. Whether traveling for business or leisure, our AC cab to Mumbai T2 combines comfort, reliability, and affordability for your airport transfer needs."
  }
],
"tableData": [
  ["Pune to Mumbai Airport Cab", "-Cab from Pune to Mumbai T2"],
  ["Pune to Mumbai International Airport taxi", "-Affordable Pune to Airport cab"],
  ["Pune to Mumbai Airport drop service", "-Luxury cab Pune to Mumbai Airport"],
  ["One-way Pune Airport cab service", "-Online Pune to Mumbai Airport cab booking"],
  ["Fast cab Pune to Mumbai Airport", "-SUV cab Pune to Mumbai Airport"],
  ["Pune to Mumbai Airport chauffeur service", "-Pune to Mumbai domestic terminal cab"],
  ["Family cab Pune to Airport Mumbai", "-Night cab Pune to Mumbai Airport"],
  ["AC cab Pune to Mumbai T2", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and Punctual Pune to Mumbai Airport Transfers",
    "WhyChoosedescription": "We understand the importance of reaching the airport on time, especially for early morning or late-night flights. Our Pune to Mumbai Airport cab service is designed to ensure you never miss a flight. With real-time traffic updates and experienced drivers, we plan your journey meticulously to avoid any delays or last-minute stress, making your airport transfer smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for a Relaxing Ride",
    "WhyChoosedescription": "Our fleet includes well-maintained sedans, SUVs, and premium cars equipped with comfortable seating, ample legroom, and sufficient space for your luggage. Whether you’re traveling alone or with family, our vehicles provide a relaxing and enjoyable environment during the approximately 3 to 4-hour journey from Pune to Mumbai Airport, helping you arrive refreshed and ready."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of the best routes between Pune and Mumbai Airport, including alternative paths to avoid traffic jams. They prioritize your safety and comfort, adhering to traffic rules and maintaining a smooth driving style, ensuring a secure and stress-free travel experience every time you book with us."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer competitive and transparent pricing for Pune to Mumbai Airport cabs, with no hidden fees or surprises at the end of your trip. Our clear billing system allows you to plan your budget confidently, knowing exactly what you’ll pay upfront. Plus, our affordable rates deliver great value for comfortable, reliable airport transfers."
  },
  {
    "WhyChooseheading": "24/7 Availability to Match Your Flight Schedule",
    "WhyChoosedescription": "Our cab services operate round the clock to cater to flights arriving or departing at any time of day or night. Whether you have an early morning flight or a late-night arrival, our Pune to Mumbai Airport cabs are ready to serve you whenever you need, ensuring convenience and peace of mind."
  },
  {
    "WhyChooseheading": "Easy Booking Process and Responsive Customer Support",
    "WhyChoosedescription": "Booking your Pune to Mumbai Airport cab is quick and effortless through our website or customer support team. Our representatives are available 24/7 to assist with your reservations, answer any queries, and accommodate special requests, making the entire process smooth from start to finish."
  },
  {
    "WhyChooseheading": "Safety and Security Assured for Peace of Mind",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles undergo regular maintenance, safety inspections, and cleaning. Equipped with seat belts, GPS tracking, and other safety features, our cabs provide a secure environment, letting you relax and enjoy your trip without worry."
  },
  {
    "WhyChooseheading": "Personalized Service to Enhance Your Travel Experience",
    "WhyChoosedescription": "We strive to deliver exceptional customer service with courteous drivers, clean vehicles, and attention to detail. From assisting with luggage to offering local travel tips, we make your Pune to Mumbai Airport transfer comfortable, efficient, and pleasant, ensuring a positive experience every time."
  }
]














    }










const faqData = [
  {
    question: "Can I book a cab from Pune to Mumbai Airport with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and on-time cab services from Pune to Mumbai Airport, available 24/7 for domestic and international flights."
  },
  {
    question: "How long does it take to travel from Pune to Mumbai Airport by cab?",
    answer: "The journey typically takes around 3.5 to 4.5 hours, depending on traffic and weather conditions."
  },
  {
    question: "What types of cabs are available for this route?",
    answer: "We provide a variety of vehicles such as sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for different passenger and luggage needs."
  },
  {
    question: "Can I schedule a cab in advance for a flight from Mumbai Airport?",
    answer: "Absolutely. You can pre-book your cab for timely airport drop-off by using our website, mobile app, or customer service line."
  },
  {
    question: "Are one-way cabs available from Pune to Mumbai Airport?",
    answer: "Yes, Deva Cabs offers cost-effective one-way cab services without return fare obligations."
  },
  {
    question: "Do your drivers ensure on-time airport drop-off?",
    answer: "Yes, our drivers are punctual and experienced in airport transfers, ensuring you reach the airport well in time for your flight."
  },
  {
    question: "Are tolls and parking included in the fare?",
    answer: "Toll and parking charges are usually extra and will be clearly mentioned during the booking process."
  },
  {
    question: "Is your service available late at night or early morning?",
    answer: "Yes, Deva Cabs operates round the clock, so you can travel any time from Pune to Mumbai Airport."
  },
  {
    question: "Is it safe for solo travelers to take a cab from Pune to Mumbai Airport?",
    answer: "Yes, our drivers are background-verified, and we prioritize the safety of all passengers, including solo and female travelers."
  },
  {
    question: "Why choose Deva Cabs for Pune to Mumbai Airport cab services?",
    answer: "With timely service, clean vehicles, professional drivers, and upfront pricing, Deva Cabs is a trusted choice for airport transfers."
  }
];

const testimonialData = [
  {
    id: 17,
    name: 'Mr. Ashok Bhagat',
    role: 'IT Professional',
    review: 'Booked a cab from Pune to Mumbai Airport for an early morning flight. The driver arrived on time, and the entire experience was hassle-free. Excellent service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 18,
    name: 'Ms. Shraddha Nene',
    role: 'Frequent Flyer',
    review: 'Deva Cabs is my go-to for Pune to Mumbai Airport travel. Always reliable, clean cars, and professional drivers. Highly recommend!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://devacab.com/assets/images/pune-to-mumbai-airport-cab.jpg", // Replace with actual image URL
  "description": "Book affordable and reliable Pune to Mumbai Airport cab service with Deva Cabs. Offering luxury, AC, SUV, chauffeur-driven cabs for one-way and night airport drop services with online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/pune-to-mumbai-airport-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Pune to Mumbai Airport Cab | Reliable & Affordable Airport Drop | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport cab service with Deva Cabs. Luxury, AC, SUV, and chauffeur-driven cabs available for one-way and night airport drop services. Fast and affordable with online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Airport Cab, Cab from Pune to Mumbai T2, Pune to Mumbai International Airport taxi, Affordable Pune to Airport cab, Pune to Mumbai Airport drop service, Luxury cab Pune to Mumbai Airport, One-way Pune Airport cab service, Online Pune to Mumbai Airport cab booking, Fast cab Pune to Mumbai Airport, SUV cab Pune to Mumbai Airport, Pune to Mumbai Airport chauffeur service, Pune to Mumbai domestic terminal cab, Family cab Pune to Airport Mumbai, Night cab Pune to Mumbai Airport, AC cab Pune to Mumbai T2" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetomumbaiairportcab;